import type { Dispatch, SetStateAction } from 'react';
import React, { useState } from 'react';
import { FormProvider } from '../common/form/FormContext';
import HireResourceSplashScreen from './HireResourceSplashScreen';
import StepperHireResource from './StepperHireResource';

export default ({
    resourceTypes,
    setHireResourceVisible,
    selectedResType
}: {
    resourceTypes: string[];
    setHireResourceVisible: Dispatch<SetStateAction<boolean>>;
    selectedResType: string;
}) => {
    const [resourceTypeIndex, setResourceTypeIndex] = useState(-1);
    const [splashScreenVisible, setSplashScreenVisible] = useState(true);

    const onAddClicked = () => {
        setResourceTypeIndex(selectedResType ? resourceTypes.findIndex((type) => type === selectedResType) : -1);
    };

    const onSplashScreenClose = (isResourceModalOpen: boolean) => {
        setSplashScreenVisible(false);
        !isResourceModalOpen && setHireResourceVisible(false);
    };

    return (
        <>
            <HireResourceSplashScreen
                onAddClicked={onAddClicked}
                onSplashScreenClose={onSplashScreenClose}
                splashScreenVisible={splashScreenVisible}
                selectedResType={selectedResType}
            />
            {resourceTypeIndex > -1 && selectedResType !== '' && (
                <FormProvider state={selectedResType} disableFunctionalStateUpdate>
                    <StepperHireResource
                        resType={selectedResType}
                        onCancelStepper={() => {
                            setResourceTypeIndex(-1);
                            setHireResourceVisible(false);
                        }}
                    />
                </FormProvider>
            )}
        </>
    );
};
